// Pure redirect seam. Centralised so tests can replace it and so we never
// stash the Stripe URL in app state/localStorage. Use only after
// validatePaymentResponseForRedirect returns ok=true.

import { assertCheckoutMutationAllowed } from "./productionMode";

export type StripeRedirectImpl = (url: string) => void;

let _impl: StripeRedirectImpl = (url: string) => {
  if (typeof window !== "undefined" && window.location) {
    window.location.assign(url);
  }
};

export function performStripeRedirect(url: string): void {
  assertCheckoutMutationAllowed("redirect to payment provider");
  _impl(url);
}

/** Test-only override. */
export function __setStripeRedirectImpl(impl: StripeRedirectImpl): void {
  _impl = impl;
}

export function __resetStripeRedirectImpl(): void {
  _impl = (url: string) => {
    if (typeof window !== "undefined" && window.location) {
      window.location.assign(url);
    }
  };
}
